import type { Action } from 'redux'
import { defaultGetParams as getParams } from '../../signalr/helpers'
import type { InvokeDefinition } from '../../signalr/types'
import { addOrUpdateBooks, fetchBooksFailure } from './actions'
import type { Book } from './types'

export const fetchBooksDefinition: InvokeDefinition<[], Book[], Action> = {
  method: 'GetTradeBooks',
  getParams,
  mapResponse: addOrUpdateBooks,
  mapError: fetchBooksFailure
}
